/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-did-update-set-state */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import Dropzone from 'react-dropzone';
import {
  Modal,
  ModalHeader,
  ModalBody,
  Input,
  ModalFooter
} from 'reactstrap';
import { Link } from 'react-router-dom';
import * as XLSX from 'xlsx';
import moment from 'utils/moment';
import icon from '../../icons/GateModule.png';
import successIcon from '../../icons/success.png';
import SectionHeader from '../../components/sectionHeader';
import Table from './Table';
import styles from '../invoices/InvoicesList.module.scss';
import listStyles from './list.module.scss';
import tStyles from '../../styles/general.module.scss';
import Button from '../../components/button';
import SelectInput from './components/SelectInput';
import PulpoField from '../../pulpo_visualizer/fields';
import Loading from '../../components/loading';
import { savePlanData, getPlanSchedule, getPlanList, getTemplate } from './redux/actions';
import { excelFileExtensions, checkFilesValidation } from '../../utils/helpers';
import Separator from '../../components/separator';
import Gantt from './Gantt';
import SelectDate from './components/SelectDate';

class List extends Component {
  constructor(props) {
    super(props);
    this.state = {
      excelHeaders: [],
      uploadModal: 'false',
      excelModal: 'false',
      scheduleModal: 'false',
      gateDropdown: 'false',
      successModal: 'false',
      popupId: null,
      showFormErrors: false,
      planNameError: false,
      uniqueError: false,
      daysError: false,
      info: {},
      mappedFields: {},
      loadingStatus: false,
      selected: {},
      gateList: [],
      requiredFieldError: false,
      fieldErrors: {
        plan_name: true
      },
      requiredFields: [
        'flight_number', 'arrival_airport',
        'departure_airport', 'arrival_time', 'departure_time', 'operation_days'
      ],
      gateFields: [
        { id: 'schedule_type', title: 'Schedule' },
        { id: 'gate', title: 'Gate #' },
        { id: 'tail_number', title: 'Tail #' },
        { id: 'flight_number', title: 'Flight #' },
        { id: 'airline', title: 'Airline' },
        { id: 'arrival_airport', title: 'Arrival Airport' },
        { id: 'departure_airport', title: 'Departure Airport' },
        { id: 'arrival_time', title: 'Arrival Time' },
        { id: 'departure_time', title: 'Departure Time' },
        { id: 'aircraft_type', title: 'Aircraft Type' },
        { id: 'operation_days', title: 'Days of Operations' },
        { id: 'over_night', title: 'Overnight' },
        { id: 'info_seats', title: 'Seats' },
        { id: 'info_weight', title: 'Weight' },
        { id: 'info_sub_fleet', title: 'Sub Fleet' },
        { id: 'info_type_service', title: 'Type Service' },
        { id: 'info_group_name', title: 'Group Name' },
        { id: 'start_date', title: 'Start Date' },
        { id: 'end_date', title: 'End Date' },
        { id: 'dept_flt', title: 'Departure Flight #' }
      ],
      selectionRange: {
        date1: moment(new Date()).startOf('day').toISOString()
      }
    };
  }

  componentDidMount() {
    const {
      actionPlanSchedule
    } = this.props;
    actionPlanSchedule();
  }

  static getDerivedStateFromProps(props, state) {
    if (props.list) {
      return { ...state,
        gateList: props.list
      };
    }
    return state;
  }

  componentDidUpdate(prevProps) {
    const { saveAction, actionPlanSchedule, scheduleaction, planSchedule, actionPlanList } = this.props;
    const { loadingStatus, selected } = this.state;
    if (prevProps.saveAction.loading === true && saveAction.success === true && loadingStatus === true) {
      this.setState({ scheduleModal: 'false', loadingStatus: saveAction.loading, successModal: 'true' });
      actionPlanSchedule();
    }

    if (prevProps.scheduleaction.loading === true && scheduleaction.loading === false && loadingStatus === true) {
      this.setState({ loadingStatus: scheduleaction.loading });
    }

    if (planSchedule?.length > 0 && Object.keys(selected).length===0) {
      actionPlanList(planSchedule[0]?.id);
      this.setState({ selected: { key: planSchedule[0]?.id, name: planSchedule[0]?.title } });
    }
  }

  handleUpload = () => {
    const { actionGetTemplate } = this.props;
    this.setState({ uploadModal: 'true' });
    actionGetTemplate();
  }

  toggleUploadModal = () => {
    const { uploadModal } = this.state;
    this.setState({ uploadModal: !uploadModal });
  }

  toggleExcelModal = () => {
    const { excelModal } = this.state;
      this.setState({ excelModal: !excelModal, daysError: false });
  }

  toggleScheduleModal = () => {
    const { scheduleModal } = this.state;
    this.setState({ scheduleModal: !scheduleModal });
  }

  toggleSuccessModal = () => {
    const { successModal } = this.state;
    this.setState({ successModal: !successModal });
  }

  handleDropDown = (id) => {
    const { gateDropdown } = this.state;
    this.setState({ gateDropdown: !gateDropdown });
    this.setState({ popupId: id });
  };

  handleEdit = (id) => {
    const { history } = this.props;
    history.push(`/gateManagement/${id}/edit`);
  }

  handleFile = (answer) => {
    const valid = checkFilesValidation(answer[0], excelFileExtensions);
    if (!valid) return;
    this.setState({ InvalidData: false, file: answer[0] });
    const reader = new FileReader();
    reader.onload = (evt) => {
      const bstr = evt.target.result;
      const wb = XLSX.read(bstr, { type: 'binary' });

      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];

      const range = XLSX.utils.decode_range(ws['!ref']);
      const excelData = [];

      const headers = [];
      for (let C = range.s.c; C <= range.e.c; ++C) {
        const cell_address = { c: C, r: range.s.r };
        const cell_ref = XLSX.utils.encode_cell(cell_address);
        const header = ws[cell_ref] && ws[cell_ref].w;
        if (header) headers.push(header.toUpperCase());
      }
      if (headers.length > 1) {
        let R = range.s.r + 1;
        for (R; R <= range.e.r; ++R) {
            const row_list = {};
            for (let C = range.s.c; C <= range.e.c; ++C) {
                const cell_address = { c: C, r: R };
                const cell_ref = XLSX.utils.encode_cell(cell_address);
                if (ws[cell_ref]?.w) row_list[headers[C]] = ws[cell_ref]?.w;
            }
            if (Object.keys(row_list).length > 0) {
            excelData.push(row_list);
            }
        }
      }
      this.setState({ excelHeaders: headers, excelData, uploadModal: 'false', excelModal: 'true' });
    };
    reader.readAsBinaryString(answer[0]);
  }

  handleMappedFields = (id, value) => {
    this.setState(prevState => ({
      mappedFields: {
        ...prevState.mappedFields,
        [id]: value
      }
    }));
  }

  handleAnswerChanged = (answer, fieldId) => {
    if (fieldId==='plan_name') {
      this.setState({ planNameError: false });
    }
    this.setState(prevState => ({
      info: {
        ...prevState.info,
        [fieldId]: answer
      }
    }));
  };

  handleFieldErrorChanged = (id, value) => {
    this.setState(prevState => ({
      fieldErrors: {
        ...prevState.fieldErrors,
        [id]: value
      }
    }));
  }

  handleExcelData = () => {
    const { requiredFields, mappedFields, daysError } = this.state;
    let noErrors = true;
    requiredFields.forEach((required) => {
      if (Object.values(mappedFields).filter(value => value === required).length === 0) noErrors = false;
    });
    const uniqueValues = new Set(Object.values(mappedFields));
    let uniqueError = false;
    if (uniqueValues.size !== Object.values(mappedFields).length) {
      uniqueError = true;
    }

    if (noErrors && !uniqueError && !daysError) {
      this.setState({ excelModal: 'false', scheduleModal: 'true' });
    } else if (daysError) {
      this.setState({ daysError: true });
    } else {
      this.setState({ requiredFieldError: true, uniqueError });
    }
  }

  handleChange = (e) => {
    const { actionPlanList } = this.props;
      this.setState({ selected: e });
    actionPlanList(e?.key);
  }

  handleOperationDays = (input) => {
    if (!input) return [];

    const dayMap = {
      MONDAY: 0,
      TUESDAY: 1,
      WEDNESDAY: 2,
      THURSDAY: 3,
      FRIDAY: 4,
      SATURDAY: 5,
      SUNDAY: 6,
      EVERYDAY: 7
    };

    const upperInput = input.toUpperCase().trim();

    let parts;

    if (/[\s,]/.test(upperInput)) {
      parts = upperInput.split(/[\s,]+/);
    } else if (/^\d+$/.test(upperInput)) {
      parts = upperInput.split('');
    } else {
      parts = [upperInput];
    }

    return parts
      .flatMap((part) => {
        const trimmed = part.trim();
        if (Object.prototype.hasOwnProperty.call(dayMap, trimmed)) return dayMap[trimmed];
        const num = +trimmed;
        return !Number.isNaN(num) && num >= 1 && num <= 8 ? num - 1 : [];
      });
  };

  handleChangeOperationDays = (days) => {
    const data = [];
    days.map((day) => {
      switch (day) {
        case 0:
          data.push('Monday');
          break;
        case 1:
          data.push('Tuesday');
          break;
        case 2:
          data.push('Wednesday');
          break;
        case 3:
          data.push('Thursday');
          break;
        case 4:
          data.push('Friday');
          break;
        case 5:
          data.push('Saturday');
          break;
        case 6:
          data.push('Sunday');
          break;
        case 7:
          data.push('Everyday');
          break;
        default:
          break;
      }
      return null;
    });
    return data.join(', ');
  }

  splitFlightCode = (flight) => {
    const match = flight.match(/^([A-Z]+)(\d+)$/i);
    if (match) {
      return {
        airlineCode: match[1],
        flightNumber: match[2]
      };
    }
    return null;
  };

  handleSave = () => {
    const { fieldErrors, excelData, mappedFields, info } = this.state;
    const { actionSavePlanData, planSchedule, profile } = this.props;
    const noErrors = Object.keys(fieldErrors).every(
      k => fieldErrors[k] === false
    );
    const planNameError = planSchedule?.length > 0 && planSchedule?.some(val => val.title === info?.plan_name);
    if (planNameError===true) { this.setState({ planNameError: true }); }
    if (noErrors && !planNameError) {
      this.setState({ loadingStatus: true });
      const response = {};
      response.data = [];
      const reverseFields = Object.entries(mappedFields).reduce((acc, [key, value]) => {
        acc[value] = key;
        return acc;
      }, {});
      excelData.forEach((excelRow) => {
        const row = {
          'info': {}
        };

        Object.keys(excelRow).forEach((mapField) => {
          if (mappedFields[mapField]) {
            if (mappedFields[mapField] === 'arrival_airport' && excelRow[mapField] !== profile?.portal_airport?.code) {
              if (excelRow[mapField] === profile?.portal_airport?.code || excelRow[mapField] === profile?.portal_airport?.iata_code) {
                row.from_city_icao = excelRow[reverseFields?.departure_airport];
                row.arrival_flight_number = excelRow[reverseFields?.flight_number]?.replace(/\s+/g, '');
                row.to_city_icao = '';
                row.schedule_arrival = moment(excelRow[reverseFields?.arrival_time], 'hh:mm').format('HH:mm');
                row.schedule_departure = moment(excelRow[reverseFields?.departure_time], 'hh:mm').format('HH:mm');
                const { airlineCode } = this.splitFlightCode(excelRow[reverseFields?.flight_number]?.replace(/\s+/g, '') || '');
                if (airlineCode) row.info.airline_code = airlineCode;
              }
            } else if (mappedFields[mapField] === 'departure_airport') {
              if (excelRow[mapField] === profile?.portal_airport?.code || excelRow[mapField] === profile?.portal_airport?.iata_code) {
                row.to_city_icao = excelRow[reverseFields?.arrival_airport]?.replace(/\s+/g, '');
                row.departure_flight_number = excelRow[reverseFields?.flight_number]?.replace(/\s+/g, '');
                row.from_city_icao = '';
                row.schedule_arrival = moment(excelRow[reverseFields?.arrival_time], 'hh:mm').format('HH:mm');
                row.schedule_departure = moment(excelRow[reverseFields?.departure_time], 'hh:mm').format('HH:mm');
                const { airlineCode } = this.splitFlightCode(excelRow[reverseFields?.flight_number]?.replace(/\s+/g, '') || '');
                if (airlineCode) row.info.airline_code = airlineCode;
              }
            } else if ((mappedFields[mapField]==='start_date')||(mappedFields[mapField]==='end_date')) {
              row[mappedFields[mapField]] = moment(excelRow[mapField]).format('YYYY-MM-DD');
            } else if ((mappedFields[mapField]==='operation_days')) {
              if (excelRow[mapField] !== '') {
                row[mappedFields[mapField]] = this.handleOperationDays(excelRow[mapField]?.match(/\d+/g)?.join('') || '');
              }
            } else if ((mappedFields[mapField]?.startsWith('info_'))) {
              row.info[mappedFields[mapField].replace('info_', '')] = excelRow[mapField];
            } else {
              row[mappedFields[mapField]] = excelRow[mapField];
            }
          }
        });
        if (!row?.dept_flt) {
          const existDataIndex = response.data.findIndex(d => (d?.dept_flt === row?.departure_flight_number));
          if (existDataIndex !== -1) {
            response.data[existDataIndex] = {
              ...response.data[existDataIndex],
              departure_flight_number: row?.departure_flight_number,
              departure_time: row?.departure_time,
              schedule_departure: row?.schedule_departure,
              to_city_icao: row?.to_city_icao,
              end_date: row?.end_date
            };
          } else {
            response.data.push(row);
          }
        } else {
          response.data.push(row);
        }
      });
      response.title = info?.plan_name;
      response.valid_from = moment(info?.valid_from).format('YYYY-MM-DD');
      response.valid_until = moment(info?.valid_until).format('YYYY-MM-DD');
      actionSavePlanData(response);
    } else {
      this.setState({ showFormErrors: true });
    }
  }

  handleDateChange = (date) => {
    let start_date = new Date(date);
    start_date.setHours(0, 0, 0, 0);
    start_date = start_date.toISOString();
    this.setState(prev => ({
      ...prev,
      selectionRange: {
        date1: start_date
      }
    }));
  }

  render() {
    const { gateList, uploadModal, gateDropdown, popupId, excelHeaders, excelModal,
      excelData, gateFields, scheduleModal, successModal, mappedFields, showFormErrors,
      info, selected, loadingStatus, planNameError, requiredFieldError, requiredFields,
      uniqueError, daysError, selectionRange } = this.state;
    const { planSchedule, scheduleUrl, history } = this.props;

    const gantt_view = (history?.location?.pathname || '')?.includes('/gateManagement/gantt_view');
    return (
      <>
        <SectionHeader
          icon={icon}
          translationID="gates.title"
          defaultTitle="Manage Gates"
        >
          <Button action="primary" translationID="gate.new.addBtn" defaultText="Upload Schedule"
          onClick={this.handleUpload} />
        </SectionHeader>
        <Loading loadingStatus={loadingStatus} />
        <div style={{ display: 'flex' }} className={styles.toolbar}>
          <div className={styles.counter}>
            <div className={`${styles.count} d-flex jsutify-centent-between`} style={{ width: '100%', color: 'black' }}>
                <span style={{ marginTop: '5px' }}>
                  <FormattedMessage id="gate.schedule" defaultMessage="Schedule" />
                </span>
                {planSchedule?.length > 0 && (
                  <SelectInput
                    value={selected}
                    options={planSchedule?.map(plan => ({
                    key: plan.id,
                    name: plan.title
                    }))}
                    onChange={e => this.handleChange(e)}
                  />
                )}
            </div>
          </div>
          <div className="d-flex align-items-center">
            {gantt_view && (
              <SelectDate
                onDateChange={this.handleDateChange}
                selectDate={moment(selectionRange.date1)}
                gates
              />

            )}
            <Separator />
            <Link to={!gantt_view ? '/gateManagement/gantt_view' : '/gateManagement'}>
              <FormattedMessage
                id={!gantt_view ? 'workorder.detail.gantt_view' : 'assets.table_view'}
                defaultMessage={!gantt_view ? 'Gantt View' : 'Table View'}
              />
            </Link>
          </div>
        </div>
        <div className={styles.invoiceContainer}>
          {gantt_view ? (
            <Gantt data={gateList} selectionRange={selectionRange} />
          ) : (
            gateList && (
              <Table info={gateList}
                handleDropDown={this.handleDropDown}
                gateDropdown={gateDropdown}
                popupId={popupId}
                handleEdit={this.handleEdit}
                handleDays={this.handleChangeOperationDays}
              />
            )
          )}
        </div>
        {uploadModal==='true' && (
        <Modal
        isOpen={() => this.toggleUploadModal()}
        toggle={() => this.toggleUploadModal()}
        centered
        >
        <ModalHeader toggle={() => this.toggleUploadModal()}>Upload a file</ModalHeader>
        <ModalBody className="text-center">
          <a color="inherit" href={scheduleUrl} download>
            <FormattedMessage id="gate.list.table.action" defaultMessage="Download Template" />
          </a>
          <Dropzone
            onDrop={this.handleFile}
            disableClick
            className={listStyles.dropzone}
            multiple={false}
            accept=".xlsx, .xls"
          >
              {({ open }) => (
                  <p className={listStyles.browsetext}>
                    <FormattedMessage
                      id="gate.logo.text1"
                      defaultMessage="Drag an excel file here or"
                    />
                    <button type="button" onClick={() => open()}>
                      <FormattedMessage
                        id="gate.logo.button"
                        defaultMessage="browse"
                      />
                    </button>
                    <FormattedMessage
                      id="gate.logo.text2"
                      defaultMessage="for an file to upload."
                    />
                  </p>
              )}
          </Dropzone>
        </ModalBody>
        </Modal>
        )}
        {excelModal==='true' && (
        <Modal
          isOpen={() => this.toggleExcelModal()}
          centered
          size="lg"
          style={{ maxWidth: '1360px' }}
          >
        <ModalHeader toggle={() => this.toggleExcelModal()}>Match Fields</ModalHeader>
        <ModalBody className="text-center" style={{ maxHeight: '500px', overflowY: 'scroll' }}>
          <table className={tStyles.table}>
            <thead>
              <tr>
                {excelHeaders.map(header => (
                  <th style={{ padding: '10px', width: '130px' }}>
                    <Input type="select" name="Select Field" id="mappedFields"
                      value={mappedFields[header]}
                      onChange={e => this.handleMappedFields(header, e.target.value)}
                      style={{ fontSize: '15px' }}
                    >
                      <option value={undefined} id={header} />
                        {gateFields.map(gateField => (
                          <option value={gateField.id} id={gateField.id} style={{ fontSize: '15px' }}>{gateField.title}</option>
                      ))}
                    </Input>
                  </th>
                ))}
              </tr>
              <tr style={{ fontSize: '12px' }}>
                {excelHeaders.length > 0 && excelHeaders.map(column => (
                  <th style={{ lineHeight: '20px' }}>
                    {column}
                  </th>
                ))}
              </tr>
            </thead>
            <tbody>
              {excelData.map(e => (
                <tr>
                  {excelHeaders.map(column => <td>{e[column]}</td>)}
                </tr>
              ))}
            </tbody>
          </table>
        </ModalBody>
        <ModalFooter>
          <div className={listStyles.footerButtons}>
            <span style={{ marginRight: '20px' }}><Button action="teritary" translationID="gate.new.addBtn"
              defaultText="Cancel" onClick={() => this.toggleExcelModal()} />
            </span>
            <span><Button action="secondary" translationID="gate.new.addBtn"
              defaultText="Save" onClick={this.handleExcelData} />
            </span>
          </div><br />
          <div>
            {!uniqueError && requiredFieldError && (
              <small style={{ color: 'red' }}>
                  You have to select all the following required Fields:<br />
                  {requiredFields.map(field => (<>{`  ${field},`}</>))}
              </small>
            )}
            {uniqueError && (
              <small style={{ color: 'red' }}>The fields are selected by multiple times?</small>
            )}
            {daysError && (
              <small style={{ color: 'red' }}>Please fill empty cells</small>
            )}
          </div>
        </ModalFooter>
        </Modal>
        )}
        {scheduleModal==='true' && (
        <Modal
          isOpen={() => this.toggleScheduleModal()}
          centered
          size="lg"
        >
        <ModalHeader toggle={() => this.toggleScheduleModal()}>Schedule Fields</ModalHeader>
        <ModalBody>
          <PulpoField
            key="plan_name"
            id="plan_name"
            type="string"
            translationID="job.settings.type_name"
            title="Plan Name"
            isRequired
            handleValueChange={(a, b) => this.handleAnswerChanged(a, b)}
            answer={info?.plan_name}
            handleFieldErrorChanged={this.handleFieldErrorChanged}
            showFieldErrors={showFormErrors}
          />
          {planNameError && showFormErrors && (
            <small style={{ color: 'red' }}>
              <FormattedMessage
                id="planname.errors.not_blank"
                defaultMessage="Plan Name Already exists."
              />
            </small>
          )}
          <PulpoField
            key="valid_from"
            id="valid_from"
            type="date"
            translationID="job.settings.type_name"
            title="Valid From"
            isRequired
            handleValueChange={(a, b) => this.handleAnswerChanged(a, b)}
            answer={info?.valid_from}
            handleFieldErrorChanged={this.handleFieldErrorChanged}
            showFieldErrors={showFormErrors}
          />
          <PulpoField
            key="valid_until"
            id="valid_until"
            type="date"
            translationID="job.settings.type_name"
            title="Valid Until"
            isRequired
            handleValueChange={(a, b) => this.handleAnswerChanged(a, b)}
            answer={info?.valid_until}
            handleFieldErrorChanged={this.handleFieldErrorChanged}
            showFieldErrors={showFormErrors}
          />
        </ModalBody>
        <ModalFooter>
          <div className={listStyles.footerButtons}>
            <span style={{ marginRight: '20px' }}><Button action="teritary" translationID="gate.new.addBtn"
              defaultText="Cancel" onClick={() => this.toggleScheduleModal()} />
            </span>
            <span>
              <Button
                action="secondary" translationID="gate.new.addBtn"
                defaultText="Save" onClick={this.handleSave}
              />
            </span>
          </div>
        </ModalFooter>
        </Modal>
        )}
        {successModal==='true' && (
        <Modal
          isOpen={() => this.toggleSuccessModal()}
          toggle={() => this.toggleSuccessModal()}
          centered
          style={{ maxWidth: '370px', maxHeight: '407px' }}
        >
        <ModalBody className="text-center">
          <img src={successIcon} alt="success" width="112px" height="96px" style={{ marginTop: '30px' }} />
          <p style={{ fontSize: '18px', paddingTop: '33px', fontWeight: 'bold', fontFamily: 'lato' }}>Success</p>
          <p style={{ textAlign: 'center', letterSpacing: '0px', color: '#8C9EA7', opacity: 1, fontSize: '15px', padding: '0px 43px' }}>
            Plan Data Saved Successfully!
          </p>
          <div style={{ margin: '30px' }}><Button action="secondary" translationID="gate.new.addBtn"
            defaultText="Ok" onClick={() => this.toggleSuccessModal()} style={{ margin: '30px' }} />
          </div>
        </ModalBody>
        </Modal>
      )}
      </>
    );
  }
}

List.propTypes = {
  history: PropTypes.shape({}).isRequired,
  match: PropTypes.shape({}).isRequired
};

const mapStateToProps = state => ({
  planSchedule: state.gate.planSchedule,
  list: state.gate.list,
  saveAction: state.gate.saveAction,
  scheduleaction: state.gate.scheduleaction,
  scheduleUrl: state.gate.scheduleUrl,
  profile: state.auth.profile
});

const mapDispatchToProps = dispatch => ({
  actionSavePlanData: (data) => {
    dispatch(savePlanData(data));
  },
  actionPlanSchedule: () => {
    dispatch(getPlanSchedule());
  },
  actionPlanList: (id) => {
    dispatch(getPlanList(id));
  },
  actionGetTemplate: () => {
    dispatch(getTemplate());
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(List);
